import { EmailTemplateApi } from 'api/EmailTemplateApi';
import { backendApiClient } from 'container/backendApiClient';

export const emailTemplateApi = new EmailTemplateApi(backendApiClient);
